import { FieldPattern } from '..';

import { filterDateOptionsByVisibility } from '@nw/shared/utils';

import { RADIO_GROUP } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';
import {
  getDefaultRadioOption,
  getRadioOptions,
  prepareOptions
} from '../../../../utils/FieldUtils';

import DependentField from '../DependentField';

interface RadioOption {
  label: string;
  value: string;
}

interface DateSelectionOption extends RadioOption {
  max_visibility_time?: string;
  should_show_next_week?: boolean;
  condition?: string;
}

class RadioGroupFormField extends DependentField {
  readonly type: string = RADIO_GROUP;
  options!: RadioOption[];
  reRenderedFields: string[] = [];
  maxVisibilityTime?: string;

  constructor(
    radioGroupFieldData: FormFieldsType,
    reRenderedFields: string[] = []
  ) {
    super(radioGroupFieldData, getDefaultRadioOption(radioGroupFieldData));

    const rawOptions = getRadioOptions(radioGroupFieldData);
    this.maxVisibilityTime = radioGroupFieldData.max_visibility_time;
    this.optionsType = radioGroupFieldData.options_type;
    const mappedOptions = rawOptions.map(
      (option: string | RadioOption | DateSelectionOption) => {
        if (
          typeof option === 'object' &&
          'label' in option &&
          'value' in option
        ) {
          if (
            (this.optionsType === 'DATE_SELECTION' ||
              this.optionsType === 'CONDITIONAL_DATE_SELECTION') &&
            'max_visibility_time' in option
          ) {
            return option as DateSelectionOption;
          }
          return option as RadioOption;
        }
        return prepareOptions(option);
      }
    );

    // Filter options if it's a DATE_SELECTION type
    this.options =
      this.optionsType === 'DATE_SELECTION'
        ? filterDateOptionsByVisibility(mappedOptions, this.maxVisibilityTime)
        : mappedOptions;

    this.reRenderedFields = reRenderedFields;
  }

  override match<T>(p: FieldPattern<T>): T {
    return p.RadioGroupFormField(this);
  }
}

export default RadioGroupFormField;
